import { useEffect } from 'react'

import { GridApi } from 'components/AgGrid/types'

import { useFilterMenuOptions } from './FilterOptions/filterOptions.hooks'
import { useSelectedFilters } from './SelectedFilters/selectedFilters.hooks'
import { FilterDef, OptionProps, ValuesData } from './agGridFilters.types'

type UseAgGridFiltersProps = {
  valuesData: ValuesData
  filterDefs: FilterDef[]
  gridApi?: GridApi | null
  hideSearch?: boolean
  uniqueValuesByFilter: Record<string, string[]>
}

type UseAgGridFiltersReturnType = {
  options: OptionProps[]
  resetFilters: () => void
}

export const useAgGridFilters = ({
  valuesData,
  filterDefs,
  gridApi,
  hideSearch,
  uniqueValuesByFilter,
}: UseAgGridFiltersProps): UseAgGridFiltersReturnType => {
  const {
    selectedFilters,
    selectedFiltersOption,
    handleUpdateFilters,
    handleRemoveFilter,
    handleResetFilters,
  } = useSelectedFilters(filterDefs)
  const filterMenuOptions = useFilterMenuOptions({
    filterDefs,
    selectedFilters,
    uniqueValuesByFilter,
    valuesData,
    handleUpdateFilters,
    handleRemoveFilter,
    hideSearch,
  })

  useEffect(() => {
    if (!gridApi) return

    gridApi.setFilterModel(selectedFilters)
  }, [gridApi, selectedFilters])

  const options = [selectedFiltersOption, ...filterMenuOptions]

  return {
    options,
    resetFilters: handleResetFilters,
  }
}
